import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { apiService } from "../../services/api";

export default function ProtectedAdminRoute() {
  const [status, setStatus] = useState<"checking" | "ok" | "fail">("checking");

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setStatus("fail");
      return;
    }

    let cancelled = false;
    apiService
      .getProfile()
      .then(() => {
        if (!cancelled) {
          setStatus("ok");
        }
      })
      .catch(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        if (!cancelled) {
          setStatus("fail");
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (status === "checking") {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#666",
          fontSize: 18,
        }}
      >
        Проверка сессии...
      </div>
    );
  }

  if (status === "fail") {
    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />;
}
